import sanitizeHTML from "sanitize-html";

export default {
  install(Vue) {
    Vue.prototype.$sanitize = sanitizeHTML;
  },
};
